import React from 'react'
import { ButtonBase } from '@mui/material'
import { Button } from '@resiliatech/birdsong'
import { GoalGroupCard } from 'Generated/graphql-types'
import { Typography } from '@material-ui/core'
import { PersonOff } from '@mui/icons-material'
import {
  GoalTitle,
  EmptyGoalGroupCardContainer,
  Actions,
  EmptyGoalGroupSection,
} from './FunderGoals.styled'
import { ADD_GOAL_DISABLED_COPY } from './utils'

type EmptyGoalGroupCardProps = {
  goalGroup: GoalGroupCard
  isAddGoalDisabled: boolean
  isInteractive?: boolean
  onAddGoal: () => void
}

export const EmptyGoalGroupCard = ({
  goalGroup,
  isAddGoalDisabled,
  onAddGoal,
  isInteractive = goalGroup.numGrantees > 0,
}: EmptyGoalGroupCardProps) => {
  const BaseContainer = isInteractive ? ButtonBase : React.Fragment

  return (
    <BaseContainer>
      <EmptyGoalGroupCardContainer>
        <EmptyGoalGroupSection>
          {goalGroup.title && (
            <>
              <GoalTitle data-testid='goalTitle' variant='h6'>
                {goalGroup.title}
              </GoalTitle>
              <Typography
                variant='h6'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <PersonOff />
                No Grantees. Reach out to your Customer Success Manager (CSM)
                for support.
              </Typography>
              <Actions>
                <Button
                  isDisabled={isAddGoalDisabled}
                  label={
                    isAddGoalDisabled ? ADD_GOAL_DISABLED_COPY : 'Add Goal'
                  }
                  onClick={onAddGoal}
                  variant='primary'
                />
              </Actions>
            </>
          )}
        </EmptyGoalGroupSection>
      </EmptyGoalGroupCardContainer>
    </BaseContainer>
  )
}
